import { render, staticRenderFns } from "./PatientImages.vue?vue&type=template&id=07475b18&"
import script from "./PatientImages.vue?vue&type=script&lang=js&"
export * from "./PatientImages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports